module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', [_c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls2"
  }, [_vm._v("L. D.")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls3"
  }, [_vm._v("Knorr")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls4"
  }, [_c('span', {
    staticClass: "pubitCssCls5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls4"
  }, [_c('span', {
    staticClass: "pubitCssCls5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls4"
  }, [_c('span', {
    staticClass: "pubitCssCls5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls6"
  }, [_vm._v("The")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls7"
  }, [_vm._v("Leviticus Mission")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls8"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls9"
  }, [_vm._v("The RV Mysteries")])]), _vm._v(" "), _c('p', {
    staticClass: "pubitCssCls1"
  }, [_c('span', {
    staticClass: "pubitCssCls9"
  }, [_vm._v("Book ONE")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7bf2f690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/fa34bd67ba7d478ea498a017dfec88b8.vue
// module id = 54
// module chunks = 0